import { MatPaginatorIntl } from '@angular/material/paginator';

const rangeLabel = (page: number, pageSize: number, length: number) => {
    if (0 == length || 0 == pageSize) {
        return $localize`:@@paginator.rangeLabelEmpty:0 von ${length}:INTERPOLATION:`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

    return $localize`:@@paginator.rangeLabel:${startIndex + 1}:INTERPOLATION: - ${endIndex}:INTERPOLATION_1: von ${length}:INTERPOLATION_2:`;
};

export function getPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel = $localize`:@@paginator.itemsPerPageLabel:Einträge pro Seite:`;
    paginatorIntl.firstPageLabel = $localize`:@@paginator.firstPageLabel:Erste Seite`;
    paginatorIntl.nextPageLabel = $localize`:@@paginator.nextPageLabel:Nächste Seite`;
    paginatorIntl.previousPageLabel = $localize`:@@paginator.previousPageLabel:Vorige Seite`;
    paginatorIntl.lastPageLabel = $localize`:@@paginator.lastPageLabel:Letzte Seite`;
    paginatorIntl.getRangeLabel = rangeLabel;

    return paginatorIntl;
}
